<template>
    <v-card>
         <v-toolbar
        color="primary"
        dark
        >
            <v-toolbar-title>
            Programa de incentivo do frentista
            </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <h3 class="mt-2">
            Com programa de incentivo do frentista, você recebe um centavo a cada dois litros abastecidos.
            Sem custos adicionais. Aproveite, cadastre-se e ganhe muito mais.
          </h3>
          <h3 class="mt-2 mb-2">Obs: Para o recebimento do dinheiro é necessário uma conta PicPay.</h3>
          <v-checkbox style="justify-content: center; align-items: center;" color="primary" v-model="aceitaTermos" label="Concorda"></v-checkbox>
          <h2 class="display-1 font-weight-light primary--text mt-4" style="text-align: center">Cadastre-se</h2>
          <v-container grid-list-md>
            <v-layout wrap>
          <v-flex xs12>
            <v-text-field
                v-model="email"
                class="pb-3 mt-4"
                hide-details
                box label="E-mail"
            />
          </v-flex>
          <v-flex xs6>
            <v-text-field
                v-model="telefone"
                class="pb-3 mt-2"
                hide-details
                box label="Telefone"
                mask="(##) #####-####"
            />
          </v-flex>
          <v-flex xs6>
            <v-text-field
                v-model="username_picpay"
                class="pb-3 mt-2"
                hide-details
                box label="Nome de usuário picpay"
            />
          </v-flex>
          </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
            <v-btn class="ma-2" round @click="$emit('fechar')">Voltar</v-btn>
            <v-spacer></v-spacer>
            <v-btn :disabled="!email || !telefone || !aceitaTermos" class="ma-2" round color="primary" @click="dialog=true">Confirmar</v-btn>
        </v-card-actions>
        <v-dialog v-model="dialog" persistent max-width="400">
            <pin v-if="dialog" @autenticado="confirmar" :frentistaSelecionado="frentistaSelecionado" @fechar="dialog = false"/>
        </v-dialog>
    </v-card>
</template>

<script>

import Pin from '@/components/dialogs/DialogPin'

export default {
  props: [ 'frentistaSelecionado' ],
  data () {
    return {
      email: '',
      telefone: '',
      username_picpay: '',
      aceitaTermos: false,
      dialog: false,
      frentistaDetalhes: null
    }
  },
  components: { Pin },
  methods: {
    confirmar () {
      if (!this.aceitaTermos) {
        alert('Termos não aceitos')
        return
      }
      if (this.email) {
        this.$store.dispatch('programaIncentivo', {
          'id_frentista': this.frentistaSelecionado.id_frentista,
          'email': this.email,
          'cnpj': this.frentista.posto.cnpj,
          'username_picpay': this.username_picpay,
          'telefone': this.telefone
        }).then(() => {
          this.$emit('fechar')
        })
      }
    },
    carregarFrentista () {
      this.$store.dispatch('detalhesFrentista', { 'id': this.frentistaSelecionado.id_frentista }).then(value => {
        this.frentistaDetalhes = value
        if (value.pessoa) {
          this.email = value.pessoa.email ? value.pessoa.email : ''
          this.telefone = value.pessoa.telefone ? value.pessoa.telefone : ''
        }
      })
    }
  },
  mounted () {
    if (this.frentistaSelecionado) {
      this.$store.dispatch('detalhesFrentista', { 'id': this.frentistaSelecionado.id_frentista }).then(value => {
        this.carregarFrentista()
      })
    }
  },
  computed: {
    frentista () {
      return this.$store.getters.frentista
    }
  }
}
</script>
